import { Box } from "../../../../../mads";
import { useScreenInfo } from "../../../../../shared/util/useScreenInfo";
import { useFullScreenVJActive } from "../../../hooks/useFullScreenVJActive";

import React from "react";
import { StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

interface ConditionalSafeAreaWrapperProps {
  readonly children: React.ReactNode;
  readonly withTopSafeArea: boolean;
  readonly panHandlers?: object;
}

export function ConditionalSafeAreaWrapper({
  children,
  withTopSafeArea,
  panHandlers,
}: ConditionalSafeAreaWrapperProps) {
  const isFullScreenVJActive = useFullScreenVJActive();
  const { isPortrait } = useScreenInfo();
  const brandedColorBackgroundMaxHeight = isPortrait ? 100 : 70;

  if (isFullScreenVJActive) {
    // In Hero VJ there are no top safe area
    return (
      <Box
        sx={[styles.heroContainer, { paddingTop: brandedColorBackgroundMaxHeight }]}
        {...(panHandlers as object)}
      >
        {children}
      </Box>
    );
  }

  // Normal VJ: with top safe area, solid nav
  return (
    <SafeAreaView
      edges={withTopSafeArea ? ["top"] : []}
      style={styles.normalContainer}
      {...(panHandlers as object)}
    >
      {children}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  heroContainer: {
    flex: 1,
  },
  normalContainer: {
    // Fill via height/width:100% rather than flex:1. This is the root of an
    // RSD island rendered directly under a react-navigation screen (a
    // non-RSD/native flex container). RSD's static analysis can't see the
    // native flex parent, so `flex:1` here triggers a "display:flex is
    // required on the parent" dev error in the strict bundle. `height/
    // width:100%` fill the definite-sized nav screen identically on native
    // without being flex-item props, so no warning. Equivalent fill on the
    // non-strict RN surface (verified against the control group).
    height: "100%",
    width: "100%",
  },
});
